import React from 'react';
import { Route, Routes } from 'react-router-dom';
import DeepLinkHandlePage from './DeepLinkHandlePage';
import DeepLinkGuidePage from './DeepLinkGuidePage';

export default function DeepLinkRoot() {
  return (
    <Routes>
      <Route path='/' element={<DeepLinkHandlePage />} />
      <Route path="/guide" element={<DeepLinkGuidePage />} />
    </Routes>
  );
}
